import template from './ws-signature-pad.tmpl.html';
import wsSignaturePadController from './ws-signature-pad.controller';

const wsSignaturePadComponent = {
  template,
  controller: wsSignaturePadController,
  bindings: {
    onSave: '&',
    onRedo: '&',
  },
};

export default wsSignaturePadComponent;



// WEBPACK FOOTER //
// ./src/signature-pad/ws-signature-pad.component.js